import { Autocomplete, TextField } from "@mui/material";
import { useMemo } from "react";
import { useLidarClearance } from "./LidarClearanceContext";
import type { LidarClearanceAxis } from "./schemas";
import t from "./translations";

type Props = {
  region: string;
  excludeAxisIds: Set<number>;
  value: number | null;
  onChange: (axisId: number | null) => void;
};

export default function AxisPicker({
  region,
  excludeAxisIds,
  value,
  onChange,
}: Props) {
  const { axes } = useLidarClearance();

  const options = useMemo(
    () =>
      axes
        .filter(
          (axis) => axis.region === region && !excludeAxisIds.has(axis.id)
        )
        .sort((a, b) => a.name_en.localeCompare(b.name_en)),
    [axes, region, excludeAxisIds]
  );

  const selected = options.find((axis) => axis.id === value) ?? null;

  return (
    <Autocomplete<LidarClearanceAxis>
      options={options}
      value={selected}
      onChange={(_event, next) => onChange(next?.id ?? null)}
      getOptionLabel={(option) => option.name_en}
      isOptionEqualToValue={(option, current) => option.id === current.id}
      renderInput={(params) => <TextField {...params} label={t.AxisLabel} />}
    />
  );
}
